class LoginService {
    login = (data) => {
      console.log(data);
      return fetch("http://apps.codebetter.in:8082/quickserve/auth/login"
      , {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    };
  }
  export default new LoginService();